import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getUnderlyingLiveFeed } from '../../stores/underlying-live-feed/getters';
import { underlyingFoldLargeSize } from '../../data/underlying-fold-size';
import { underlyingTickerSymbolList } from '../../helpers/underlying-ticker-symbol-list';
import { getUnderlyingPriceTicker } from '../../stores/local-settings/getters';
import ValueContainer from './ValueContainer';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16.9px',
    letterSpacing: '0px',
    color: 'var(--color-pnl-card-font-3)',
    alignItems: 'center',
    width: '100%',
    flex: 1,

    [theme.breakpoints.up('md')]: {
      fontSize: 13,
    },

    // eslint-disable-next-line no-useless-computed-key
    [`@media (min-width: ${underlyingFoldLargeSize}px)`]: {
      fontSize: 14,
      flex: 'initial',
      justifyContent: 'flex-start',
    },
  },
}));

function useTickerSymbolList() {
  const newSymbols = [];
  const symbolsFilter = useSelector(getUnderlyingPriceTicker);

  for (let index = 0; index < underlyingTickerSymbolList.length; index++) {
    const element = underlyingTickerSymbolList[index];
    const value = symbolsFilter[element.value] === true ? true : false;

    if (!value) {
      continue;
    }

    newSymbols.push(element);
  }

  return newSymbols;
}

function useIsShow() {
  const symbols = useTickerSymbolList();

  const isLTP = useSelector((state) => {
    const value = getUnderlyingLiveFeed(state);

    return value['NIFTY BANK'] ||
      value['NIFTY 50'] ||
      value['NIFTY FIN SERVICE'] ||
      value['NIFTY MID SELECT'] ||
      value['SENSEX'] ||
      value['BANKEX']
      ? true
      : false;
  });

  return isLTP && symbols.length ? true : false;
}

const LiveUderlyingSpot = ({ className = '' }) => {
  const classes = useStyles();
  const symbols = useTickerSymbolList();
  const isShow = useIsShow();

  return (
    <>
      {isShow && (
        <div className={`${classes.root} ${className}`}>
          {symbols.map((item) => (
            <ValueContainer
              symbol={item.value}
              label={item.label}
              key={item.value}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default LiveUderlyingSpot;
